import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=1e84d4c1&scoped=true&"
import script from "./Bonuses.vue?vue&type=script&lang=js&"
export * from "./Bonuses.vue?vue&type=script&lang=js&"
import style0 from "./Bonuses.vue?vue&type=style&index=0&id=1e84d4c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e84d4c1",
  null
  
)

export default component.exports